<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`出车费用汇总表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceExpenseSummary",
  components: { Wxts },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      breadcrumb: [
        { name: "财务管理" },
        { name: "出车费用汇总表" },
      ],
      wxtsList: [
        {
          name: '如需增减字段，可在【系统设置】',
          path: '/finance/drivingFee',
          pathName: '【出车费用配置】',
          tailName: '处设置。',
        },
      ],
      formCtrl: [
        {
          ...this.ctrls.month
        },
        {
          ...this.ctrls.fleet
        },
        {
          ...this.ctrls.license
        },
      ],
      cols: [
        //{ keyName: "month", label: "月份", width: '110px' },
        { keyName: "vtype", label: "车辆类型", minwidth: '110px' },
        { keyName: "license", label: "车牌号", minwidth: '110px' },
        { keyName: "driver", label: "司机姓名", minwidth: '110px' },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          title: '费用明细',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ license, month }) => {
            const o = {}
            if (month) {
              o['predict_unloading_date'] = this.getMonthRange(month)
            }
            const path = '/finance/tabledetails'
            this.setState({
              key: 'formInline' + path,
              value: o,
            })
            this.$router.push(
              `/finance/tabledetails?license=${license}&month=${month}`
            );
          },
        },
      ],
      baseParams: ['month'],
      formInline: {
        month: '',
        fleet: null,
        license: '',
      },
    };
  },
  methods: {
    setOptions({ team, month, dayauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      if (!this.formInline.fleet) {
        this.formInline.fleet = ''
      }
      this.MONTH = this.formInline.month = month
      const arr = []
      dayauth.map(v => {
        const o = {
          keyName: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
        }
        if (v.authname.length > 3) {
          o.width = 100
        }
        arr.push(o)
      })
      this.cols.push(...arr)
      this.cols.push(
        { keyName: "doil", label: "现金加油", align: 'right', className: 'pr30', minwidth: '110px' },
        //{ keyName: "moneydoil", label: "油气卡加油", align: 'right', className: 'pr30', width: '120px' },
        { keyName: "dtotal", label: "费用合计", align: 'right', className: 'pr30', minwidth: '110px' },
      )
      this.getTotalProperty = [
        ...arr.map(v => v.keyName), 'doil', 'dtotal'
      ]
      this.doLayout()
      this.$forceUpdate()
      console.log({ ...this.formInline })
      this.getList()
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  /deep/ .wxts {
    .b {
      width: 300px;
    }
  }
}

/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>